import { useEffect, useState } from "react";
import axios from "axios";
import { API, useAuth } from "@/App";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import DashboardHeader from "@/components/layout/DashboardHeader";
import PartnersStrip from "@/components/PartnersStrip";
import WhatsNewTiles from "@/components/WhatsNewTiles";
import { toast } from "sonner";

/**
 * Hub home — the landing for logged-in members.
 *
 * Layout:
 *   <DashboardHeader />            (hero + 6 tile menu + greeting + edit profile + home icon)
 *   <WhatsNewTiles />              (4-tile magazine row: featured / My Portal LIVE / events / suggestion box)
 *   <Footer />
 *
 * Clicking the Suggestion Box tile sends a quick suggestion via /api/suggestions
 * (using the form on /dashboard's Suggest tab as the primary submission UI).
 */
const Home = () => {
  const { user } = useAuth();
  const [featured, setFeatured] = useState(null);

  useEffect(() => {
    axios.get(`${API}/users/me/whats-new`)
      .then((res) => setFeatured(res.data?.featured || null))
      .catch(() => setFeatured(null));
  }, [user]);

  return (
    <div className="min-h-screen bg-white" data-testid="home-page">
      <Navbar />
      <DashboardHeader />

      <div className="container-main py-8 md:py-10">
        <WhatsNewTiles
          featured={featured}
          onSuggestClick={() => {
            // Premium members: hop to /dashboard?tab=suggest. Free members: show toast prompt.
            if (user?.is_admin || user?.is_founder || user?.is_founding_member || (user?.membership_tier && user?.membership_tier !== "free")) {
              window.location.href = "/dashboard?tab=suggest";
            } else {
              toast.info("The Suggestion Box is part of My Portal — available to Founding Members and paid tiers.");
            }
          }}
        />
      </div>

      <PartnersStrip />
      <Footer />
    </div>
  );
};

export default Home;
